import * as THREE from 'three';

let pocketTexture = null;
/** Broad, edgeless gaussian — nothing like the hot node glow. */
function getPocketTexture() {
  if (pocketTexture) return pocketTexture;
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = 256;
  const ctx = canvas.getContext('2d');
  const g = ctx.createRadialGradient(128, 128, 0, 128, 128, 128);
  g.addColorStop(0, 'rgba(255,255,255,0.22)');
  g.addColorStop(0.35, 'rgba(255,255,255,0.1)');
  g.addColorStop(0.65, 'rgba(255,255,255,0.03)');
  g.addColorStop(1, 'rgba(255,255,255,0)');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 256, 256);
  pocketTexture = new THREE.CanvasTexture(canvas);
  return pocketTexture;
}

/**
 * Whisper of a floor under a nest. The real mass is the cluster smoke
 * reaching back; this is only a faint place-marker, never a hot cloud.
 */
export function createNestHull(tint) {
  const pocket = new THREE.Mesh(
    new THREE.PlaneGeometry(2, 2),
    new THREE.MeshBasicMaterial({
      map: getPocketTexture(),
      color: new THREE.Color(tint),
      transparent: true,
      opacity: 0,
      blending: THREE.NormalBlending,
      depthWrite: false,
      fog: true,
    }),
  );
  pocket.userData.targetOpacity = 0.035;
  pocket.renderOrder = -6;
  return pocket;
}

export function disposeNestHull(pocket) {
  pocket.geometry.dispose();
  pocket.material.dispose();
}
